(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2430],{

/***/ 29651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ FaChevronLeft; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaChevronLeft(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 320 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FiCalendar; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiCalendar(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 38626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





/** ========== */





var PostItem = function PostItem(_ref) {
  var _post$categories;

  var post = _ref.post,
      layout = _ref.layout;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  if (layout === "vertical") {
    var _post$featuredImage;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "flex h-full flex-1 flex-col rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833] xl:max-w-sm",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            as: "h3",
            className: "text-lg font-semibold text-bbc-brand-800 line-clamp-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "mt-4 line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-[5px] text-sm font-medium text-white",
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
              size: 18
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })]
    });
  }

  if (layout === "horizontal") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "text-bbc-brand-700",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          as: "h3",
          className: "text-lg font-medium line-clamp-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: post === null || post === void 0 ? void 0 : post.uri,
            children: post === null || post === void 0 ? void 0 : post.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mt-6 inline-flex items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
            size: 18
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: "inline-block pl-2 text-sm",
            children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {});
};

/* harmony default export */ __webpack_exports__["Z"] = (PostItem);
PostItem.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */

/***/ }),

/***/ 68148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ articles; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/functions.js
var functions = __webpack_require__(98989);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaSearch.js
var FaSearch = __webpack_require__(53253);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiCalendar.js
var FiCalendar = __webpack_require__(68840);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormNewsletter/index.js
var FormNewsletter = __webpack_require__(32314);
// EXTERNAL MODULE: ./components/molecules/PostItem/index.js
var PostItem = __webpack_require__(38626);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/ai/AiOutlineArrowRight.js

function AiOutlineArrowRight(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaChevronLeft.js
var FaChevronLeft = __webpack_require__(29651);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaChevronRight.js
var FaChevronRight = __webpack_require__(20303);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/hk/articles/Slider.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var Component = function Component(_ref) {
  var id = _ref.id,
      category = _ref.category,
      posts = _ref.posts;

  var _useState = (0,react.useState)(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var swiper = {
    preloadImages: false,
    lazy: true,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletActiveClass: "!bg-bbc-brand-500 !opacity-100"
    },
    navigation: {
      nextEl: ".bbc-button-next-".concat(id),
      prevEl: ".bbc-button-prev-".concat(id),
      disabledClass: "lg:hidden"
    },
    slidesPerView: 3,
    spaceBetween: 30,
    // Responsive breakpoints
    breakpoints: {
      1280: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 1
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 40
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 40,
        navigation: true
      }
    }
  };
  (0,react.useEffect)(function () {
    var currentSwiper = document.querySelector(".swiper-".concat(id));

    if (currentSwiper) {
      setCurrentIndex(currentSwiper.swiper.activeIndex);
    }
  }, [currentIndex]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: posts.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat(id === 0 ? "" : "mt-10 lg:mt-20"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container mb-6 flex items-center justify-between lg:items-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: category.name,
          className: "text-2xl font-semibold leading-9 lg:text-bbc-30px"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
          href: category.uri,
          className: "flex text-bbc-brand-600",
          children: ["See more", /*#__PURE__*/(0,jsx_runtime.jsx)(AiOutlineArrowRight, {
            size: 24,
            className: "ml-2"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "overflow-hidden",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container relative",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
            modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_, swiper_esm/* Pagination */.tl],
            className: "swiper-".concat(id, " !overflow-visible")
          }, swiper), {}, {
            onSlideChange: function onSlideChange(swiperCore) {
              var activeIndex = swiperCore.activeIndex;
              setCurrentIndex(activeIndex);
            },
            children: [posts.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: "col-3 !h-auto ".concat(index === currentIndex ? "opacity-100" : index === currentIndex + 1 ? "opacity-20 lg:opacity-100" : index === currentIndex + 2 ? "opacity-20 xl:opacity-100" : "opacity-20"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "h-full",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostItem/* default */.Z, {
                    post: item
                  })
                })
              }, index);
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bbc-slide-pagination relative  block pt-6 text-center lg:invisible"
            })]
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bbc-button-prev-".concat(id, " absolute top-1/2 left-0 z-10 hidden h-12 w-12 -translate-y-1/2 -translate-x-1/2 cursor-pointer items-center justify-center rounded-full bg-bbc-brand-600 transition-all duration-150 ease-in-out hover:opacity-60 lg:flex"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronLeft/* FaChevronLeft */.b, {
              size: 16,
              className: "text-white"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bbc-button-next-".concat(id, " absolute top-1/2 right-0 z-10 hidden h-12 w-12 -translate-y-1/2 translate-x-1/2 cursor-pointer items-center justify-center rounded-full bg-bbc-brand-600 transition-all duration-150 ease-in-out hover:opacity-60 lg:flex"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronRight/* FaChevronRight */.D, {
              size: 16,
              className: "text-white"
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var Slider = (Component);
Component.defaultProps = {
  id: 0,
  posts: [],
  category: {}
};
;// CONCATENATED MODULE: ./components/templates/hk/articles/index.js















var articles_Component = function Component(_ref) {
  var _firstPost$categories, _data$banner, _data$banner2, _data$banner3, _data$banner4, _data$banner5, _data$banner6, _data$banner6$image, _data$banner7, _data$banner8, _firstPost$featuredIm;

  var data = _ref.data,
      posts = _ref.posts,
      categories = _ref.categories;

  var _useState = (0,react.useState)(),
      keyWord = _useState[0],
      setKeyWord = _useState[1];

  var _useState2 = (0,react.useState)([]),
      results = _useState2[0],
      setResults = _useState2[1];

  var firstPost = posts[0] || {};
  var category = firstPost === null || firstPost === void 0 ? void 0 : (_firstPost$categories = firstPost.categories) === null || _firstPost$categories === void 0 ? void 0 : _firstPost$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  var handleSearch = function handleSearch(keyWord) {
    var keyWordLowerCase = keyWord.toLowerCase().trim();
    setKeyWord(keyWordLowerCase);
    setResults(keyWordLowerCase ? posts.filter(function (item) {
      return (item === null || item === void 0 ? void 0 : item.title.toLowerCase().trim().includes(keyWordLowerCase)) || (item === null || item === void 0 ? void 0 : item.excerpt.replace(/<[^>]+>/g, "").toLowerCase().trim().includes(keyWordLowerCase));
    }) : []);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-fix-min-h-569",
        title: data === null || data === void 0 ? void 0 : (_data$banner = data.banner) === null || _data$banner === void 0 ? void 0 : _data$banner.title // Author="Content team"
        ,
        breadcrumbs: data === null || data === void 0 ? void 0 : (_data$banner2 = data.banner) === null || _data$banner2 === void 0 ? void 0 : _data$banner2.breadcrumbs,
        description: data === null || data === void 0 ? void 0 : (_data$banner3 = data.banner) === null || _data$banner3 === void 0 ? void 0 : _data$banner3.description,
        bgColor: "bg-bbc-gradient-8" // TimeRead="20 min read"
        // Date="18/02/2022"
        // DataTrustpilot={trustpilot}
        ,
        leftClassName: "relative lg:mt-0 col-12 lg:col-5" // LeftClassName="relative mt-4 lg:mt-0 col-12 lg:col-8 xl:col-7 lg:max-w-[665px]"
        // RightClassName="relative col-12 lg:col-4 xl:col-5"
        ,
        rightClassName: "relative col-12 lg:col-7 text-center ".concat(data !== null && data !== void 0 && (_data$banner4 = data.banner) !== null && _data$banner4 !== void 0 && _data$banner4.className ? data === null || data === void 0 ? void 0 : (_data$banner5 = data.banner) === null || _data$banner5 === void 0 ? void 0 : _data$banner5.className : "lg:-mt-[70px]"),
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: data === null || data === void 0 ? void 0 : (_data$banner6 = data.banner) === null || _data$banner6 === void 0 ? void 0 : (_data$banner6$image = _data$banner6.image) === null || _data$banner6$image === void 0 ? void 0 : _data$banner6$image.src,
          width: 559,
          height: 474,
          className: "".concat(data !== null && data !== void 0 && (_data$banner7 = data.banner) !== null && _data$banner7 !== void 0 && _data$banner7.classNameImg ? data === null || data === void 0 ? void 0 : (_data$banner8 = data.banner) === null || _data$banner8 === void 0 ? void 0 : _data$banner8.classNameImg : "max-w-[375px]", " lg:w-full lg:max-w-full"),
          alt: "banner",
          priority: true
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "overflow-hidden rounded-[49px] border border-bbc-neutral-600",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                    type: "text",
                    placeholder: "Enter your keyword",
                    onChange: function onChange(e) {
                      return handleSearch(e.target.value);
                    },
                    className: "form-input h-10 w-full border-0 bg-transparent px-4 tracking-[0.25px] text-[rgba(51,51,51,0.5)] focus:ring-0"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-auto flex items-center justify-center",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "px-4",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaSearch/* FaSearch */.U, {
                      className: "text-bbc-neutral-600",
                      size: 18
                    })
                  })
                })]
              })
            })
          })
        }), keyWord ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: !keyWord && firstPost ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "overflow-hidden rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_rgba(124,120,120,0.2)]",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "pr-0 lg:col-8 lg:pr-[15px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    alt: "",
                    image: firstPost === null || firstPost === void 0 ? void 0 : (_firstPost$featuredIm = firstPost.featuredImage) === null || _firstPost$featuredIm === void 0 ? void 0 : _firstPost$featuredIm.node,
                    wrapper: {
                      className: "w-full relative"
                    },
                    className: "aspect-[16/9] h-full w-full object-cover"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "col-12 flex flex-col justify-center px-[15px] py-4 lg:col-4",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                    as: "h3",
                    className: "text-lg  font-semibold text-bbc-brand-800 line-clamp-2 lg:text-2xl lg:leading-9 lg:line-clamp-3",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                      href: firstPost === null || firstPost === void 0 ? void 0 : firstPost.uri,
                      children: firstPost === null || firstPost === void 0 ? void 0 : firstPost.title
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mt-4 line-clamp-3 lg:mt-6",
                    dangerouslySetInnerHTML: {
                      __html: firstPost.excerpt
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap justify-between",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                        src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
                        alt: "icon",
                        width: 16,
                        height: 16
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "inline-block pl-[5px] text-sm font-medium text-white",
                        children: category.length > 0 && category[0].name
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mt-6 inline-flex items-center",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FiCalendar/* FiCalendar */.v, {
                        size: 18
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "inline-block pl-2 text-sm",
                        children: (0,functions/* formatDate */.p)(firstPost === null || firstPost === void 0 ? void 0 : firstPost.date)
                      })]
                    })]
                  })]
                })]
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
          })
        }), results.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row -mx-4 mt-8 gap-y-8",
          children: results.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 px-4 lg:col-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostItem/* default */.Z, {
                post: item
              })
            }, index);
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), keyWord && !(results.length > 0) || !posts || !(posts.length > 0) ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "border-primary text-primary mt-8 border-l-4 bg-[#fff5e3] py-4 px-6 text-center",
          children: "No results"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
      })
    }), !keyWord && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: (categories === null || categories === void 0 ? void 0 : categories.nodes.length) > 0 && (categories === null || categories === void 0 ? void 0 : categories.nodes.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Slider, {
          id: index,
          category: item,
          posts: posts.filter(function (element) {
            return element.categories.nodes.find(function (nodes) {
              return nodes.name === item.name;
            });
          })
        }, index);
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormNewsletter/* default */.Z, {})]
  });
};

/* harmony default export */ var articles = (articles_Component);
articles_Component.defaultProps = {
  data: {},
  posts: []
};

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

}]);